<p-card>
    <div fxLayout="column" class="p-12">
        <div fxLayout="row" fxFlex="100">
            <div fxFlex="70">
                <p class="pt-4 dark-color-80 subtitle-1-bold pb-8">
                    {{ "APP_CASES.LINKED_UPLOAD_CASES" | translate }}
                </p>
            </div>
        </div>

        <div fxLayout="column" fxLayoutGap="16px">
            <div fxLayout="column" fxFlex="100" class="">
                <div fxLayout="column" class="">
                    <div fxLayout="row" fxLayoutAlign="start start" class="cursor-pointer" id="am-1057">
                        <div>
                            <mat-icon class="font-size-12 badge-yellow mt-4" color="yellow">lens</mat-icon>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="start start">
                            <div class="font-size-14" fxLayout="row" fxLayoutAlign="start center">
                                <a class="badge-green" href="{{ gotoUploadIpex() }}" target="_blank">{{
                                    uploadIpexCaseInfo.InsuranceClaimNumber
                                }}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!uploadIpexCaseInfo || !uploadIpexCaseInfo.InsuranceClaimNumber">
                    <p class="">{{ "NO_DATA_FOUND" | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</p-card>
